import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { AlertTriangle, CreditCard, Info } from "lucide-react";
import { toast } from "sonner";

export const SubscriptionBanner = () => {
  const [b, setB] = useState(null);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  useEffect(() => { api.get("/billing/banner").then((r) => setB(r.data.banner)).catch(() => {}); }, []);
  if (!b) return null;
  const act = async () => {
    setBusy(true);
    try {
      if (b.action === "portal") { const { data } = await api.post("/billing/portal", { origin_url: window.location.origin }); window.location.href = data.url; return; }
      if (b.action === "resume") { await api.post("/billing/resume"); toast.success("Abonnement repris"); setB(null); return; }
      if (b.action === "offers" && b.status === "trial_expired") { navigate("/app/billing/pending"); return; }
      navigate("/app/settings#abonnement");
    } catch (e) { toast.error(e.response?.data?.detail || "Action impossible"); } finally { setBusy(false); }
  };
  const cls = b.level === "error" ? "bg-red-50 border-red-200 text-red-900" : b.level === "warning" ? "bg-amber-50 border-amber-200 text-amber-900" : "bg-blue-50 border-blue-200 text-blue-900";
  const Icon = b.level === "info" ? Info : AlertTriangle;
  return (
    <div className={`mb-5 flex flex-col sm:flex-row sm:items-center gap-3 rounded-xl border px-4 py-3 text-sm ${cls}`} data-testid="subscription-banner" data-status={b.status}>
      <Icon className="w-4 h-4 shrink-0" />
      <div className="flex-1"><div className="font-semibold">{b.title}</div><div className="text-xs opacity-80 mt-0.5">{b.message}</div></div>
      <button onClick={act} disabled={busy} className="inline-flex items-center gap-1.5 text-xs font-semibold rounded-lg bg-slate-900 text-white px-3 py-1.5 shrink-0" data-testid="subscription-banner-action"><CreditCard className="w-3.5 h-3.5" /> {b.action_label}</button>
    </div>
  );
};
